<template>
    <div>
    <el-dialog
    :visible.sync="$store.getters.showCatalogSectionDialog"
    width="80%"
    :before-close="handleClose"
    >   
        <el-container v-loading="isLoading">
            <el-header height="auto">  
                <el-row >
                    <h4>{{titleComputed}}</h4>  
                </el-row>   
                <el-row>
                    <div v-if="query.sectionId" class="catalog-sections-page__top-buttons">
                        <el-button  @click="onParentSection" v-loading="isSelectedLoading">
                            К родительской категории
                        </el-button>
                        <el-button @click="onRootSection">
                            Сбросить
                        </el-button>
                    </div>
                </el-row>                                           
            </el-header>
        
            <el-main>
                <el-form label-width="160px" label-position="left" >
                    <el-form-item label="Поиск">
                        <input
                            type="text"
                            class="el-input__inner"
                            v-model="query.q"
                            @change="onSearch"
                        />
                    </el-form-item>
                    <el-form-item label="Сортировка">
                        <el-select
                            v-model="query.sort"
                            clearable
                            no-data-text="Нет данных"
                            @change="setQuery"
                            >
                            <el-option
                                v-for="item in sortConfig"
                                :key="item.field"
                                :label="item.title"
                                :value="item.field"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-table :data="items" empty-text="Нет данных">
                    <el-table-column prop="id" label="Id" width="64"></el-table-column>
                    <el-table-column prop="title" label="Название" >
                        <template slot-scope="scope">
                            <el-button              
                            type="text"
                            class="button-name-section__dialog"
                            @click="onSection(scope.row.id)"       
                            >
                                {{ scope.row.title }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="Выбрать" width="86">
                        <template slot-scope="scope" >
                            <el-checkbox
                                :value="isChecked(items[scope.$index])"
                                @change="changeChecked(items[scope.$index])"
                            >    
                            </el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>

            <el-footer height="5%">
                <el-pagination
                background
                layout="prev, pager, next"
                :total="paginator ? paginator.total : 0"
                :current-page.sync="paginator.current_page"
                @current-change="onGetPage(paginator ? paginator.current_page : 0)"
                :hide-on-single-page="true"
                :page-size="paginator ? paginator.per_page : 0"
                :page-count="paginator ? paginator.last_page : 0"
                >
                </el-pagination>
            </el-footer>
        </el-container>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose"
            >Отмена</el-button
            >
            <el-button type="primary" @click="onSave"
            >Применить</el-button
            >
        </span>
    </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../composable/config/catalog-section-sort.config"

export default {
    props: {
        itemsPayload: [], // ids/items selected section
        isMultiple: {
            type: Boolean,
            default: false,
        },
        returnsIds: {
            type: Boolean,
            default: false,
        }
    },
    data: function(){
        return {
            title: this.isMultiple ? 'Выбор категорий' : 'Выбор категории',
            items: [],
            paginator: {},
            isLoading: false,
            isSelectedLoading: false,
            checkedItems: [],
            selectedIds: [],
            sortConfig,
            query: {
                q: '',
                page: 1,
                sort: '',
                sectionId: 0,
            },
            selectedSection: {
                title: '',
                id: 0,
                parentId: 0,
            },
        }
    },
    computed: {
        titleComputed() {
            if (this.selectedSection.title) {
                return this.selectedSection.title
            }
            return this.isMultiple ? 'Выбор категорий' : 'Выбор категории'
        }
    },
    mounted(){
        this.initSelected()
        this.getItems()
    },
    methods: {
        handleClose(){
            this.$store.commit('showCatalogSectionDialog', false);
        },
        initSelected() {
            if (this.itemsPayload?.length) {
                if (this.itemsPayload[0].id) {
                    this.selectedIds = this.itemsPayload.map(e => e.id)
                } else {
                    this.selectedIds = this.itemsPayload.map(e => e)
                    
                }
            }
        },
        async getItems(query = '') {
            this.isLoading = true
            axios.get('catalog/section/by-parent' + query)
            .then((response) => {
                this.items = response?.data?.data ?? []
                this.paginator = response.data?.meta ?? {};
            })
            .catch(() => this.items = [])
            .finally(() => { this.isLoading = false })
        },
        async fetchDetailSection(){      
            const sectionId = this.query.sectionId;
            if (!sectionId) {
                return;
            }
            this.isSelectedLoading = true
            axios.get(`catalog/section/${sectionId}`)
            .then((response) => {
                this.setSelectedSection(response.data)
            })
            .catch(() => {})
            .finally(() => this.isSelectedLoading = false)
        },
        async searchRequest(query){
            this.isLoading = true

            await axios.get('catalog/section' + query)
            .then((response) => {
                this.items = response.data?.data;
                this.paginator = response.data?.meta ?? {};
            })
            .catch((errors)=>{
                if(errors.response.status === 401){
                this.$router.push('/login');
                }
            })
            .finally(() => this.isLoading = false);
        },
        getQuery() {
          const result = {};
          
          if (this.query.page) {
            result['page']=this.query.page
          }
          if (this.query.q) {
            result['q']=this.query.q
          }

          if (this.query.sectionId) {
            result['section_id']=this.query.sectionId
          }

          if (this.query.sort) {
            const findResult = this.sortConfig.find((e) => e.field === this.query.sort)
            if (findResult) {
                result['sort'] = {
                    by: findResult.options.by,
                    order: findResult.options.order
                }
            }
          }

          if (Object.keys(result).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(result)}`
          }
          return ''
        },
        getItemById(id){
            return this.items.find((e) => e.id === id)
        },
        async setQuery() {
            if (this.query.q) {
                await this.searchRequest(this.getQuery())
            } else {
                await this.getItems(this.getQuery())
            }
        },
        async onGetPage(pageNum){
            if (pageNum) {
                this.query.page = pageNum
                await this.setQuery()
            }
        },
        isChecked(item) {
            return !!this.selectedIds.find(e => e === item.id)
        },
        setCheckedItems(item) {
            const findIndex = this.checkedItems.findIndex(e => e.id === item.id)
            if (findIndex >= 0) {
                this.checkedItems.splice(findIndex, 1)
            } else {
                if (this.isMultiple) {
                    this.checkedItems.push(item)
                } else {
                    this.checkedItems = [item]
                }
            }
        },
        setSelectedIds(item) {
            const findIndex = this.selectedIds.findIndex(e => e === item.id)
            if (findIndex >= 0) {
                this.selectedIds.splice(findIndex, 1)
            } else {
                if (this.isMultiple) {
                    this.selectedIds.push(item.id)
                } else {
                    this.selectedIds = [item.id]
                }
            }
        },
        setSelectedSection(value) {
            if (value) {
                this.selectedSection.title = value.title ?? ''
                this.selectedSection.id = value.id ?? 0
                this.selectedSection.parentId = value.parent_id ?? 0
            } else {
                this.selectedSection = {
                title: '',
                id: 0,
                parentId: 0
                }
            }
        },
        changeChecked(item) {
            if (!this.returnsIds) {
                this.setCheckedItems(item)
            }
            this.setSelectedIds(item)
        },
        onSave(){
            const propsItems = this.returnsIds ? this.selectedIds : this.checkedItems; 
            this.$emit("saveItems", [...propsItems]);
            this.handleClose()
        },
        onSection(id){            
            this.query.q = ''
            this.query.page = 1
            this.query.sort = ''
            this.query.sectionId = id;
            const item = this.getItemById(id)
            if (item) {
                this.setSelectedSection(item)
            } else if (id) {
                this.fetchDetailSection()
            } else {
                this.setSelectedSection()
            }
            this.setQuery()            
        },
        onParentSection(){
            if (this.selectedSection.parentId) {
                this.onSection(this.selectedSection.parentId)
            } else if (this.query.sectionId) {
                this.onSection(null)
            }
        },
        onRootSection(){
            this.onSection(null)
        },
        onSearch(){
            this.query.page = 1
            this.query.sectionId = 0
            this.query.sort = ''
            this.setSelectedSection()
            this.setQuery()
        }
    }
}
</script>

<style>
.button-name-section__dialog span{
  color: #606266;
}
.button-name-section__dialog:hover span {
  color: #409EFF;
}

</style>